<template>

    <h1>Wyoming Department of Health - Medicaid Waiver Applicant Portal</h1>
    <div v-if="loadingData">Loading...</div>
    <div v-else style="text-align: left;">
        <div>Welcome to the Medicaid Waiver Applicant Portal.  This site will allow you to submit an application for the Medicaid Waivers.</div>
        <br />
        <div v-if="unregistered">
            We recommend that you begin by <router-link :to="{ name: 'register' }">Registering</router-link> with the site prior to submitting an application.
            This will allow you to return to this site and see the status of your application, as well as provide additional information to the Wyoming
            Department of Health (WDH) as needed. A valid email address is required in order to register.
        </div>
        <br />
        <div v-if="registered">
            You are registered and logged into the site and you can proceed directly to the <router-link :to="{ name: 'application' }">Application</router-link>
            page and submit without being able to return and update or track your application, or if you have submitted your application, you can go to the
            <router-link :to="{ name: 'application-status' }">Application Status</router-link> page if your application has already been submitted.
        </div>
    </div>

</template>

<script setup lang="ts">
    import { onMounted, ref } from 'vue';
    import { useAuth0 } from "@/Services/Auth0/auth0-plugin";
    console.log("api from env: " + process.env.VUE_APP_PORTAL_API)
    
    const auth0 = useAuth0();
    const getAccessToken = async () => {
        if (!auth0) {
            return null;
        }

        return await auth0.getAccessToken();
    };
    const loadingData = ref(true)
        
    let unregistered = ref(true)
    let registered = ref(false)
    let isAuthenticated = false
    
    onMounted(async () => {
        try {
            const token = await getAccessToken();

            if (!token) {
                unregistered.value = true;
                registered.value = false;
            } else {
                unregistered.value = false;
                registered.value = true;
                isAuthenticated = auth0 ? auth0.isAuthenticated.value : false;
                console.log('Application Status Page is auth0 authenticated: ' + isAuthenticated);
            }
        } catch {
            console.log('Not Authenticated.');
        } finally {
            loadingData.value = false;
        }
    });    

</script>

<style>
</style>